import { TaskHistoryItem, TaskHistoryResponse } from '../../components/tasks-list/TaskHistoryModel';
import instance from '../api';
import { buildApiHeaders } from '../../utilities/configUtils';

export const fetchTasksData = async (
  assetId: string,
  startDate?: string,
  endDate?: string,
  filterBy?: string,
  filterValue?: string,
  orderBy?: string,
  orderColumn?: string,
): Promise<TaskHistoryItem[]> => {
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  if (filterBy) params.append('filterBy', filterBy);
  if (filterValue) params.append('filterValue', filterValue);
  if (orderBy) params.append('orderBy', orderBy);
  if (orderColumn) params.append('orderColumn', orderColumn);
  const url = `/actionLog/${assetId}?${params.toString()}`;
  const headers = await buildApiHeaders();
  const response = await instance.get<TaskHistoryResponse | any>(url, {
    headers,
  });
  return response.data?.noteItems ?? [];
};
